import { createMachine, sendParent, send, assign } from 'xstate';

import { createFetchMachine } from './fetch-machine';

import { navigate } from 'gatsby';

const formatRequestBody = (context) => {
  const { captchaToken, fetchData } = context;

  const body = {
    k: {
      ...fetchData,
      rt: captchaToken,
    }, // Required
    s: {}, // Optional
    o: {}, // Tracking
  };

  return JSON.stringify(body);
};

const visit = (routeName) => (context, event) => {
  const route = context.page.routes.find((route) => route.name === routeName);
  if (route) {
    navigate(route.url);
  } else {
    console.warn(
      `Page-${context.page.pageId} is missing an "${routeName}" route.`,
    );
  }
};

const checkIsNewLead = (context, event) => {
  const { captureData } = context;

  if (captureData && !captureData.fcid) {
    return true;
  }

  return false;
};

export const createTransitionMachine = (config = {}) => {
  /** @xstate-layout N4IgpgJg5mDOIC5QBswEMIFoAuAnNAdrAJbbED2BAdMRKlQeQKK67m4DEAygCoCCAJR4BtAAwBdRKAAO5EmUpSQAD0SYAjKICsVACwA2AEyjDADn0BOAMzWrWqwBoQAT0SH96quqvndpixZaAOzqWgC+YU6oGDj4RKQU1LT0YKzskNz8QmKSSCCy8olKqgiYViFU+vpBoqL+plbudk6uCJaGXuq6VlYm6hbGolYRUehYeISFlFQT8QoExARQHDlKBQmKeSW6tVRDVl1BhrpBFto9LYhaflQhFur6pv4GQeGRINHjcVPUsz+Ly2E6lyMjkGwIxUQunUQS8DW0fSMon0lwQRx01ROJlMQ2RDxGHzGsUm4Jm33BAIAcmAAO4AGTGKwkazB80hCDOoiogRqIX8dmuqNeFm5yNEFnhQVMXXUBM+xLmiTJJPmVNpDIwK2BLJ+7PMOkaQ3sVl0EoeWlRwU85ilPksyO6+jlRL+pNdqqW1PpjOEhhB+VZRS2iAGsK0Wgl+kaUrOp1R3TDoiCB0a6kM7i0Tve8vdStgYAIEABAFk0FBiABjOmLADWPGYAFs0MRkNwAJqUgD6fAAwgBpTtcJiUgAig4AkgBxLvjrt02cDngAeU7TGLfHHdNWeXWbODaOllWTBn0Wn5aaCqK6HXUMIGJuxlkzzpiuemFdw6DISz4jAIzgbcgAFdYC4OASEodsu17AcuCnGdoMpJdKTbYslwAVS4Ok223UFdX3bwHm5Y51FMLRam6UwhUzUUPFEGFdGMUwQhfL4VSVD8vwBAAxICCAIMBkB7ShsDQCtsDA2AIIIDhuKYHgewACU7Hsl2LAAFOl5KYXCA3w0ASgGUwqBNJ5yjOaE6l0K8hhvbxGIaYxDF5ViFR+KhOLQb8oF4-jBOEghRPEyTpNk+SlNXAQBCXARdN3IMDMQW9rVOGppXS6UhiFHY9BCF5DEzKV+lct9qDEitwL4ZBPwwZxJzibAMjiwNNkS0oYU8OxekCArDAOGpDFRIxdCoK1+XFZMkyzUZX3JeYqHK8D6sIRqICZf14talQkuMW4Hl6QwLGqQJdF0C0XCStMRosM7oW8fRRBOXQSrmpVFqk5bAqa7UdxaiECLqPZjACKVDFCJ50yvA69FCdNM3uB7zBe9jpne2BPtWlY-R1cF2QeDoQlCOpxXcTQCqvPwDVJuongCPxkcVVGKwqqSADViDQARIGIT9xIEYDGvWnG9zazBgmM7QtAvNN6PvGzmNG070UaG7b2e7MXVepmWdgdm0D4IDsAAC3YYgAC9IH5w2wCF379O20ozs8KNTSTe4TV5K9SINTRTxuupMz6hn3LRkcC2IJrmTt3H90wfxbmuHwJXMUjjioi6EBhfQ9muU7xX0O6zsMCJ3kYCA4CUHMtaSOgwAYZg0lwYWEodsXTBG48cTIvqpUvDPnNhUytAHiVrGsYPSWSOvUjYT8IGbraSjbjvTIDnvmPjGEqGY09GOsTMz20Cf5qnhf-tFqMCdX7vyg3jPSOMoeDqT15i412aUd+auATP9l3G5OwAxAj3FMMYUi1kM72A6CcB6Z0rAFwOGeY+SpSpqm9BgX++4oxhksITIIBheqDQzq8bOZw6IMSYixd+bFGbUHzIWEsZZKzVgIHWRszZkCYLasxWEdRUzMWhDiboqJeoAMTraDwUspTIPfDVbyv5KAAWAqBcCLdNrnwdt4Owo126NBNBZAqjhIFnm3r7ZytN7j3BkdQTy3lfICSEiJMSElVFbXUXqI6CdqiaE0HYW86dWg8L0DYZMCMdj7WsQtZmlVqpjDqg1SAXDW5gw6HYV4mg7jHHIiiDO7dYTJlvM5EmpFkyRLRhjRJ0cRYO0Yp4KyDRD5kXgc0e+CITLNL6jYK6spqFuVJA2YgUkARW0akkpeBVs5BEvvZRoBUgjzIpuREy8zQE7HmVZaahIP60KiTrPWXMiy82wCMsAYy1DOWzsPE05jd69DOjZaw7TtAnFASEKZZTolsw5gbY2psLYQBOWc0oBwRQmDqA9UI4Z5kmivBcqgfUUl+HuGmGEHydZhwWJUvCMc2rOQ6PRB4SKTADG0H3VoWivCmiaLiAu9FNlV0-kCzAjwuSdzXrfMlagrDb3IsmKZLzjhg1MCXMIQA */
  return createMachine(
    {
      context: {
        session: undefined,
        formData: undefined,
        captureData: undefined,
        ...config.context,
      },
      preserveActionOrder: true,
      predictableActionArguments: true,
      invoke: {
        src: createFetchMachine({
          main: {
            ...config?.children?.fetch?.main,
            actions: {
              ...config?.children?.fetch?.main?.actions,
              assignRequestBodyToContext: assign({
                requestBody: formatRequestBody,
              }),
            },
          },
        }),
        id: 'transition-fetch',
      },
      id: 'lead-transition',
      initial: 'idle',
      states: {
        idle: {
          initial: 'noError',
          states: {
            noError: {
              entry: 'removeErrorFromContext',
              on: {
                START: {
                  target: '#lead-transition.transitioning',
                  actions: 'assignInitialContext',
                },
              },
            },
            errored: {
              on: {
                START: {
                  target: '#lead-transition.transitioning',
                  actions: 'assignInitialContext',
                },
              },
            },
          },
        },
        transitioning: {
          always: [
            {
              target: 'transitioningNewLead',
              cond: 'isNewLead',
            },
            {
              target: 'accessAlreadyGranted',
            },
          ],
        },
        transitioningNewLead: {
          always: [
            {
              target: 'creatingFunnelContactSession',
              cond: 'isSessionAuthenticated',
            },
            {
              target: 'creatingAnonymousSession',
              cond: 'isAnonymousSessionSupported',
            },
            {
              target: 'sendingMagicLinkToEmail',
            },
          ],
        },
        sendingMagicLinkToEmail: {
          entry: ['assignCallbackUrlToContext', 'synSendSignInLinkToEmail'],
          on: {
            SYN_ACK_SEND_SIGN_IN_LINK_TO_EMAIL: {
              target: 'accessDenied',
            },
          },
        },
        creatingAnonymousSession: {
          entry: 'synSignInAnonymously',
          on: {
            SYN_ACK_SIGN_IN_ANONYMOUSLY: {
              target: 'creatingFunnelContactSession',
            },
          },
        },
        creatingFunnelContactSession: {
          entry: 'fetch',
          on: {
            FETCH_COMPLETE: {
              target: 'accessGranted',
              actions: 'assignTransitionDataToContext',
            },
            FETCH_ERROR: {
              target: '#lead-transition.idle.errored',
              actions: 'sendServerToParent',
            },
          },
        },
        accessAlreadyGranted: {
          entry: ['assignNullTransitionDataToContext', 'visitAuthorizedRoute'],
          exit: 'sendTransitionCompleteToParent',
          always: {
            target: 'idle',
          },
        },
        accessGranted: {
          always: [
            {
              target: 'accessViaRedirectRoute',
              cond: 'hasRedirectRoute',
            },
            {
              target: 'accessViaAuthorizedRoute',
              cond: 'hasAuthorizedRoute',
            },
            {
              target: 'missingRoute',
            },
          ],
        },
        missingRoute: {
          entry: 'reportMissingRoute',
        },
        accessViaRedirectRoute: {
          entry: ['visitRedirectRoute', 'sendTransitionCompleteToParent'],
          always: {
            target: 'idle',
          },
        },
        accessViaAuthorizedRoute: {
          entry: ['visitAuthorizedRoute', 'sendTransitionCompleteToParent'],
          always: {
            target: 'idle',
          },
        },
        accessDenied: {
          entry: 'visitThankYouRoute',
          exit: 'sendTransitionCompleteToParent',
          always: {
            target: 'idle',
          },
        },
      },
    },
    {
      actions: {
        visitAuthorizedRoute: visit('authorized'),
        visitRedirectRoute: visit('redirect'),
        visitThankYouRoute: visit('thankyou'),
        reportMissingRoute: (context, event) => {
          console.error(`[reportMissingRoute]`, context);
          console.error(`[reportMissingRoute]`, event);
        },
        removeErrorFromContext: assign({
          error: undefined,
        }),
        assignTransitionDataToContext: assign({
          transitionData: (_, event) => {
            return event.serverData;
          },
        }),
        assignNullTransitionDataToContext: assign({
          transitionData: () => {
            return null;
          },
        }),
        assignInitialContext: assign({
          session: (_, event) => {
            return event.session;
          },
          page: (_, event) => {
            return event.page;
          },
          captureData: (_, event) => {
            return event.captureData;
          },
          formData: (_, event) => {
            return event.formData;
          },
        }),
        fetch: send(
          (context) => {
            return {
              type: 'FETCH',
              user: context.session.user,
              fetchData: {
                smid: context.captureData.smid,
                pkid: context.formData.pkid,
                fnid: context.formData.fnid,
                esurl: context.formData.esurl,
              },
              endpoint: '/k/handle-lead-form-submit',
            };
          },
          { to: 'transition-fetch' },
        ),
        sendServerToParent: sendParent((_, event) => {
          return {
            type: 'TRANSITION_ERROR',
            error: event.serverData,
          };
        }),
        sendTransitionCompleteToParent: sendParent((context) => {
          return {
            type: 'TRANSITION_COMPLETE',
            transitionData: context.transitionData,
          };
        }),
        assignCallbackUrlToContext: assign({
          callbackUrl: (context) => {
            const { captureData } = context;
            const { smid } = captureData;

            if (!smid) {
              console.error(`Missing parameter: "smid"`);
              return;
            }

            // Build callback URL
            const callbackOrigin = window.location.origin;

            let callbackRoute = context.page.routes.find(
              (route) => route.name === 'callback',
            );

            if (!callbackRoute) {
              callbackRoute = { url: '/' };
              console.warn(
                `The "callbackRoute" is undefined. This may cause buggy behavior. Falling back to '/'`,
              );
            }

            const callbackLandingPage = callbackRoute.url
              .split('/')
              .filter(Boolean)
              .join('/');
            const callbackPath = [callbackOrigin, callbackLandingPage].join(
              '/',
            );
            const callbackParams = new URLSearchParams();
            // Append whatever params you want
            callbackParams.append('smid', smid);

            // Construct the callback URL
            const callbackUrl = [callbackPath, callbackParams].join('?');

            return callbackUrl;
          },
        }),
        synSendSignInLinkToEmail: sendParent((context) => {
          const { callbackUrl, formData } = context;
          const { em } = formData;

          const email = em.toLowerCase().trim();

          const settings = {
            email,
            actionCodeSettings: {
              url: callbackUrl,
              handleCodeInApp: true,
            },
          };

          return {
            type: 'SYN_SEND_SIGN_IN_LINK_TO_EMAIL',
            settings,
          };
        }),
        synSignInAnonymously: sendParent(() => {
          return {
            type: 'SYN_SIGN_IN_ANONYMOUSLY',
          };
        }),
        ...config?.main?.actions,
      },
      services: {
        ...config?.main?.services,
      },
      guards: {
        isSessionAuthenticated: (context) => {
          return Boolean(context?.session?.user);
        },
        isAnonymousSessionSupported: () => {
          return false;
        },
        isNewLead: checkIsNewLead,
        hasRedirectRoute: (context) => {
          return Boolean(
            context.page.routes.find((route) => route.name === 'redirect'),
          );
        },
        hasAuthorizedRoute: (context) => {
          return Boolean(
            context.page.routes.find((route) => route.name === 'authorized'),
          );
        },
        ...config?.main?.guards,
      },
    },
  );
};
